import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ServiceCard } from "@/components/ServiceCard";
import { api } from "@/lib/api";
import { Loader2, Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Favorites() {
  const { favIds } = useAuth();
  const [services, setServices] = useState(null);

  useEffect(() => { api.get("/favorites").then((r) => setServices(r.data)); }, [favIds.length]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-10">
        <h1 className="font-heading text-3xl font-extrabold text-slate-900 mb-1 flex items-center gap-2">
          <Heart className="w-7 h-7 text-rose-500 fill-rose-500" /> Meine Favoriten
        </h1>
        <p className="text-slate-500 mb-8">Deine gemerkten Angebote auf einen Blick</p>
        {services === null ? (
          <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-emerald-600" /></div>
        ) : services.length === 0 ? (
          <div className="text-center py-20 text-slate-500" data-testid="no-favorites">Noch keine Favoriten. Tippe auf das Herz-Symbol bei einem Angebot.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="favorites-grid">
            {services.map((s) => <ServiceCard key={s.id} service={s} />)}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
